import {createReducer} from '@reduxjs/toolkit'
import {collapseDescription, expandDescription} from '../actions/tickets-picker'
import {TicketsPicker} from '../types/state'

const defaultState: TicketsPicker = {
  tickets: {},
}

export const ticketsPicker = createReducer(defaultState, builder => {
  builder
    .addCase(expandDescription, (state, action) => {
      return updateTicketFlag(state, action.payload, 'expandedDescription', true)
    })
    .addCase(collapseDescription, (state, action) => {
      return updateTicketFlag(state, action.payload, 'expandedDescription', false)
    })
})

const updateTicketFlag = (state: TicketsPicker, ticketDefId: string, flag: string, value: boolean) => ({
  ...state,
  tickets: {
    ...state.tickets,
    [ticketDefId]: {...(state.tickets[ticketDefId] || {}), [flag]: value},
  },
})
